import * as React from 'react';
import classnames from 'classnames';

import { getCurrentLocale } from 'features/services/utils/env-helper';
import { LOCALE, ReadMoreAlign, HeadlineLevel, HeadlineFont} from 'features/ui/enums';
import {getCoOwningLabel, getFormattedMessage} from "features/services/utils/language-helper";

import './style.scss';

import {P} from 'components/atoms/Text/P';
import {Headline} from '@atoms/Text/Headline';
import {A} from 'components/atoms/LinksAndButtons/A';
import {ReadMore} from 'components/atoms/LinksAndButtons/ReadMore';

interface Props {
    headline: string;
    text: string;
    big?: boolean;
    url: string;
}

export const CoOwningBanner: React.FunctionComponent<Props> = ({headline, text, big, url}) => {
    const classes = classnames('co-owning-banner', 'no-styles', {
        'co-owning-banner--small': !big,
        'co-owning-banner--large': big,
    });

    return (
        <A 
            href={url} 
            className={classes} 
            route 
            title={headline} 
        >
            <Headline 
                level={big 
                    ? HeadlineLevel.H3
                    : HeadlineLevel.H4
                } 
                font={big
                    ? undefined 
                    : HeadlineFont.SERIF 
                }
                center 
            >
                {headline}
            </Headline>
            <P center>{text}</P>
            {(getCurrentLocale() === LOCALE.FI || getCurrentLocale() === LOCALE.NO)
                ? <ReadMore align={ReadMoreAlign.CENTER} text={getFormattedMessage('jm.components.CoOwningBanner.link')} />
                : <ReadMore align={ReadMoreAlign.CENTER} text={`Läs mer om ${getCoOwningLabel()}`} />
            }
        </A>
    )
};
